var map = {
	"./": 72812,
	"./App": 54111,
	"./App.js": 54111,
	"./App.test": 26029,
	"./App.test.js": 26029,
	"./components/CircularImage": 33807,
	"./components/CircularImage.css": 34764,
	"./components/CircularImage.js": 33807,
	"./components/Home": 5210,
	"./components/Home.css": 66237,
	"./components/Home.js": 5210,
	"./components/Layout": 2111,
	"./components/Layout.css": 57010,
	"./components/Layout.js": 2111,
	"./components/ResearchData": 768,
	"./components/ResearchData.js": 768,
	"./components/SimpleLinkList": 48083,
	"./components/SimpleLinkList.css": 11710,
	"./components/SimpleLinkList.js": 48083,
	"./documents/804_final_project_writeup.pdf": 81811,
	"./documents/869_final_project_writeup.pdf": 72800,
	"./documents/MEng_Thesis.pdf": 20473,
	"./documents/Memento_ECCV_2020.pdf": 23281,
	"./documents/Memento_SVRHM_Camera_ready.pdf": 81473,
	"./documents/MultidurationSaliency_CVPR_2020.pdf": 79109,
	"./documents/TurkEyes.pdf": 40311,
	"./documents/TurkEyes_chi_presentation_slides.pdf": 79836,
	"./documents/TurkEyes_vss_poster.pdf": 23966,
	"./documents/TurkEyes_vss_slides.pdf": 23095,
	"./documents/documents.txt": 12507,
	"./documents/md_saliency_svrhm_camera_ready.pdf": 78340,
	"./documents/md_saliency_svrhm_poster.pdf": 32950,
	"./documents/memento_eccv_presentation_slides.pdf": 84142,
	"./documents/memento_mic_presentation.pdf": 56989,
	"./documents/memento_svrhm_poster.pdf": 83715,
	"./documents/memento_talk_recording_downsampled.mp4": 19103,
	"./documents/multiduration_saliency_cvpr_poster.pdf": 36681,
	"./documents/multiduration_saliency_cvpr_video_pres_slides.pdf": 1941,
	"./documents/resume.pdf": 34000,
	"./documents/titles_vss_poster_2018.pdf": 91931,
	"./documents/zoommaps_visxvision_presentation.pdf": 51453,
	"./documents/zoommaps_vss_poster.pdf": 58408,
	"./global-styles.css": 58207,
	"./images/md_saliency_svrhm_poster.png": 77348,
	"./images/me.jpg": 62401,
	"./images/memento_predictions.png": 14241,
	"./images/memento_svrhm_poster.png": 82541,
	"./images/multiduration_predictions.png": 43539,
	"./images/thesis_thumbnail.png": 44558,
	"./images/titles_vss_poster_2018.png": 17389,
	"./images/turkeyes_teaser_video.mp4": 19261,
	"./images/turkeyes_thumbnail.png": 77940,
	"./images/zoommaps_visxvision_image.png": 51228,
	"./images/zoommaps_vss_poster.png": 63860,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./serviceWorker": 47001,
	"./serviceWorker.js": 47001,
	"./setupTests": 89472,
	"./setupTests.js": 89472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;